import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import { localStorageHealthCheck } from './storePersist';
import vi from '@/locale/translation/vi.json';
import { RoleState } from './role/types';

localStorageHealthCheck();

const LANG_INITIAL_STATE = vi;

const AUTH_INITIAL_STATE = {
  current: {},
  isLoggedIn: false,
  isLoading: false,
  isSuccess: false,
};
const INITIAL_SETTINGS_STATE = {
  result: {
    crm_settings: {},
    finance_settings: {},
    company_settings: {},
    app_settings: {},
    money_format_settings: {},
  },
  isLoading: false,
  isSuccess: false,
};

const roleInitialState: RoleState = {
  isLoading: false,
  isError: false,
  error: null,
  roles: [],
};

const initialState = {
  translate: LANG_INITIAL_STATE,
  auth: AUTH_INITIAL_STATE,
  settings: INITIAL_SETTINGS_STATE,
  roles: roleInitialState,
};

const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export default store;
